import classNames from 'classnames';
import {omit, sortBy} from 'lodash';
import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {
  getUberEatsConfig,
  getUberEatsWinners,
  updateUberEatsWinners,
} from '../../../../../actions/entities/uberEats';
import {postImageUpload} from '../../../../../components/NotificationEditor/components/AvatarSelect';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone';
import './index.css';

class UberEatsWinnersListWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      updateWinnersOpen: false,
      winnersSummary: [],
      winner: null,
      isEdit: false,
      clubs: [],
    };
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getUberEatsWinners(), null, this.onError);
    dispatch(getUberEatsConfig(), null, this.onError);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.winners !== this.props.winners) {
      const data = this.props?.winners?.data?.winnersSummary?.slice(0);
      const dataId = data?.map((item, index) => {
        item.id = index + 1;
        return item;
      });

      const sortTable = sortBy(dataId, match => {
        return match.order;
      });

      this.setState({
        winnersSummary: sortTable,
      });
    }

    if (prevProps.config !== this.props.config) {
      const data = this.props?.config?.data;
      if (data) {
        const clubs = Object.values(data?.clubs || {});
        this.setState({
          clubs,
        });
      }
    }
  }

  onError = error => {
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong:<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  onClickEdit(winner) {
    this.setState({
      winner,
      updateWinnersOpen: true,
      isEdit: true,
    });
  }

  onClickCreate() {
    const {clubs} = this.state;
    const club = clubs[0];

    const newWinner = {
      away: {...club, score: 0},
      date: '',
      hidden: false,
      home: {...club, score: 0},
      id: '',
      imageUrl: '',
      order: 0,
    };

    this.setState({
      updateWinnersOpen: true,
      isEdit: false,
      winner: newWinner,
    });
  }

  onCreate() {
    const data = this.state.winnersSummary.slice(0);
    data.push(this.state.winner);
    this.setState({
      winnersSummary: data,
      winner: null,
      updateWinnersOpen: false,
      isEdit: false,
    });
  }

  onChangeInput = (value, key, id) => {
    if (this.state.isEdit) {
      const data = this.state.winnersSummary.slice(0);
      const findObj = data.find(i => i.id === id);
      findObj[key] = value;
      const newData = data.map(obj => (obj.id === id ? {...findObj} : obj));
      this.setState({
        winnersSummary: newData,
        winner: findObj,
      });
    } else {
      const winnerData = this.state.winner;
      winnerData[key] = value;
      this.setState({
        winner: winnerData,
      });
    }
  };

  updateScore(match, value, id) {
    if (this.state.isEdit) {
      const data = this.state.winnersSummary.slice(0);
      const findObj = data.find(i => i.id === id);
      findObj[match]['score'] = value;
      const newData = data.map(obj => (obj.id === id ? {...findObj} : obj));
      this.setState({
        winnersSummary: newData,
        winner: findObj,
      });
    } else {
      const winnerData = this.state.winner;
      winnerData[match]['score'] = value;
      this.setState({
        winner: winnerData,
      });
    }
  }

  updateClub(clubName, key, id, score) {
    const {clubs} = this.state;
    const findClub = clubs.find(club => club.name === clubName);
    if (this.state.isEdit) {
      this.onChangeInput({...findClub, score}, key, id);
    } else {
      const winnerData = this.state.winner;
      winnerData[key] = {...findClub, score};
      this.setState({winner: winnerData});
    }
  }

  onChangeWinners = (value, key, id) => {
    const data = this.state.winnersSummary.slice(0);
    const findObj = data.find(i => i.id === id);
    findObj[key] = value;
    const newData = data.map(obj => (obj.id === id ? {...findObj} : obj));
    this.setState({
      winnersSummary: newData,
    });
  };

  submit = () => {
    const {dispatch} = this.props;
    const {winnersSummary} = this.state;

    const array = map(winnersSummary, row => {
      const home = omit(row, ['home.championshipClubId']);
      const away = omit(home, ['away.championshipClubId']);
      return omit(away, ['id']);
    });

    const data = {
      id: this.props.winners.data.id,
      type: this.props.winners.data.type,
      winnersSummary: array,
    };

    const onSuccess = () => {
      swal({
        title: 'Created !',
        type: 'success',
      });
      this.setState({winnerInfo: null, updateWinnersOpen: false});
    };
    dispatch(updateUberEatsWinners(data, onSuccess(), this.onError));
  };

  onUpload = file => {
    this.props.dispatch(
      postImageUpload(file, imageUrl =>
        this.onChangeInput(imageUrl, 'imageUrl'),
      ),
    );
  };

  render() {
    const {isFetching} = this.props;
    const {updateWinnersOpen, winnersSummary, isEdit, winner, clubs} =
      this.state;
    if (!winnersSummary && !isFetching && !clubs) return false;

    return (
      <div id="WinnersList">
        <section className="content">
          <div className="row">
            <div className="row">
              <div className="col-md-6">
                <div className="box box-default">
                  <div className="box-header with-border">
                    <h3 className="box-title pull-left">
                      <i className="fa fa-plus-circle" /> Winners list
                    </h3>
                  </div>
                  <div className="table-fixed-height">
                    <div className="text-center create-button">
                      <button
                        className="btn btn-success m-3"
                        onClick={() => this.onClickCreate()}>
                        Create winner
                      </button>
                    </div>
                    <table className="table table-responsive table-striped">
                      <thead>
                        <tr>
                          <th />
                          <th>MATCH</th>
                          <th className="text-center">SCORE</th>
                          <th className="text-center">DATE</th>
                          <th />
                          <th>DISPLAY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(winnersSummary, (winner, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div className="text-center game-week-day">
                                  <input
                                    className="form-control order"
                                    value={winner.order}
                                    onChange={event =>
                                      this.onChangeWinners(
                                        event.target.value,
                                        'order',
                                        winner.id,
                                      )
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="table-row text-left">
                                  {winner.home.name} - {winner.away.name}
                                </div>
                              </td>
                              <td>
                                <div className="table-row center">
                                  {winner.home.score} - {winner.away.score}
                                </div>
                              </td>
                              <td>
                                <div className="table-row center">
                                  {moment(winner.date).format('DD/MM/YY')}
                                </div>
                              </td>
                              <td>
                                <button
                                  className="btn btn-warning"
                                  onClick={() => this.onClickEdit(winner)}>
                                  Edit
                                </button>
                              </td>
                              <td>
                                <div className="col-sm-4 table-row">
                                  <i
                                    onClick={() =>
                                      this.onChangeWinners(
                                        !winner.hidden,
                                        'hidden',
                                        winner.id,
                                      )
                                    }
                                    className={classNames('fa fa-2x', {
                                      'fa-toggle-on': !winner.hidden,
                                      'fa-toggle-off': winner.hidden,
                                    })}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="text-center publish-button-container">
                      <button
                        className="btn btn-success publish-button"
                        onClick={() => this.submit()}>
                        {'Publish'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {updateWinnersOpen && (
                <div id="updateWinner" className="col-md-6">
                  <div className="box box-default">
                    <div className="box-header with-border">
                      <h3 className="box-title pull-left">
                        {(isEdit ? 'Edit' : 'Create') + ' winner'}
                      </h3>
                    </div>
                    <div style={{padding: '15px'}}>
                      <div className="table-fixed-height">
                        <table className="table table-responsive table-striped">
                          <thead>
                            <tr>
                              <th className="text-center">Home</th>
                              <th className="text-center">Score</th>
                              <th className="text-center">Away</th>
                              <th className="text-center">Date</th>
                              <th className="text-center">Image</th>
                            </tr>
                          </thead>
                          <tbody>
                            <td>
                              <div className="table-column">
                                <select
                                  className="form-control"
                                  value={winner?.home?.name || ''}
                                  onChange={event => {
                                    this.updateClub(
                                      event.target.value,
                                      'home',
                                      winner.id,
                                      winner.home.score,
                                    );
                                  }}>
                                  {map(Object.values(clubs), club => {
                                    return (
                                      <option value={club.name}>
                                        {club.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </td>
                            <td>
                              <div className="score-container">
                                <div className="table-column">
                                  <input
                                    className="form-control score"
                                    value={winner?.home?.score || ''}
                                    type="number"
                                    onChange={event =>
                                      this.updateScore(
                                        'home',
                                        event.target.value,
                                        winner.id,
                                      )
                                    }
                                  />
                                </div>
                                <div className="table-column">
                                  <input
                                    className="form-control score"
                                    value={winner?.away?.score || ''}
                                    type="number"
                                    onChange={event =>
                                      this.updateScore(
                                        'away',
                                        event.target.value,
                                        winner.id,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="table-column">
                                <select
                                  className="form-control"
                                  value={winner?.away?.name || ''}
                                  onChange={event => {
                                    this.updateClub(
                                      event.target.value,
                                      'away',
                                      winner.id,
                                      winner.away.score,
                                    );
                                  }}>
                                  {map(Object.values(clubs), club => {
                                    return (
                                      <option value={club.name}>
                                        {club.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </td>
                            <td>
                              <div className="table-column">
                                <DatePicker
                                  className="inputDatePicker form-control text-center"
                                  selected={
                                    (winner?.date && new Date(winner.date)) ||
                                    new Date()
                                  }
                                  onChange={date => {
                                    console.log(date);
                                    this.onChangeInput(
                                      moment(date).utc().format(),
                                      'date',
                                      winner.id,
                                    );
                                  }}
                                  dateFormat={'d/M/yyyy'}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="infoWrapper btn-container">
                                {winner?.imageUrl ? (
                                  <div className="winnerItem">
                                    <img
                                      src={`${winner?.imageUrl}`}
                                      width="90px"
                                      alt=""
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    <Dropzone
                                      onDrop={acceptedFiles => {
                                        const img = new Image();
                                        img.src = acceptedFiles[0].preview;
                                        img.onload = () => {
                                          if (img.width !== 500) {
                                            swal({
                                              title: `Oops...`,
                                              type: 'error',
                                              html: `Wrong dimensions: ${img.width} X ${img.height}<br/>Accepted dimensions: 500 x 500<br/>`,
                                            });
                                          } else {
                                            this.onUpload(
                                              acceptedFiles[0],
                                              winner.id,
                                            );
                                          }
                                        }
                                      }}
                                      className="btn btn-warning">
                                      Upload
                                    </Dropzone>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tbody>
                        </table>
                        {!this.state.isEdit && (
                          <div className="text-center create-button">
                            <button
                              className="btn btn-success m-3"
                              onClick={() => this.onCreate()}>
                              Create
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(
  state => ({
    winners: state.app.uberEats.winners,
    config: state.app.uberEats.config,
  }),
  dispatch => ({dispatch}),
)(UberEatsWinnersListWidget);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Winners/Widgets/WinnersList/index.js